const isEmpty = require("is-empty");
const initialState = {
    isAuthenticated: false,
    Margincall: {},
    loading: false
};
export default function(state = initialState, action) {
    switch (action.type) {

        case 'MARGINCALL_ADD':
        return {
                isAuthenticated: !isEmpty(action.payload),
                Margincall: action.payload
        };

        case 'MARGINCALL_UPDATE':
            return {
                isAuthenticated: !isEmpty(action.payload),
                Margincall: action.payload,
            };
        case 'SET_CURRENT_MARGINCALL':
            return {
                ...state,
                isAuthenticated: !isEmpty(action.payload),
                Margincall: action.payload
            };

        case 'MARGINCALL_LOADING':
            return {
                ...state,
                loading: true
            };
        default:
            return state;
    }
}